import React, { useState, Fragment } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { useTheme } from '@mui/material/styles';
import { Stack, Typography, Button, Popover } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CreateKit from './CreateKit';
import utils from 'components/utils';

const HeaderPage = props => {
	const theme = useTheme();
	const translate = utils.useI18N();
	const iCan = utils.usePermissions();
	const openCreate = useStoreState(state => state.kit.create.openCreate);
	const setOpenCreate = useStoreActions(dispatch => dispatch.kit.create.setOpenCreate);
	const [anchorElCreate, setAnchorElCreate] = useState(null);

	const handleClickCreate = event => {
		setAnchorElCreate(event.currentTarget);
		setOpenCreate(true);
	};

	const handleCloseCreate = event => {
		setAnchorElCreate(null);
		setOpenCreate(false);
	};

	const buttonList = [
		{
			label: translate('kit.add'),
			icon: <AddIcon sx={{ color: theme.palette.custom.white }} />,
			condiction: iCan('MANAGE_KIT'),
			href: null,
			onclick: handleClickCreate,
			type: 'dark'
		}
	];

	return (
		<Fragment>
			<Stack
				direction={{ xs: 'row', md: 'row', sm: 'row' }}
				justifyContent="flex-stat"
				alignItems="center"
				spacing={1}
				variant="wrapperColor"
			>
				<Typography variant="titlePage">{translate('common.menu.kit')}</Typography>
				<Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={1} sx={{ width: '100%' }}>
					{buttonList.map(btn => (
						<Button
							key={btn.label}
							variant={btn.type}
							href={btn.href}
							onClick={btn.onclick}
							endIcon={btn.icon}
							sx={{ display: btn.condiction ? 'inherit' : 'none' }}
						>
							{btn.label}
						</Button>
					))}
				</Stack>
			</Stack>

			{/* Popover Create */}
			<Popover
				open={openCreate}
				anchorEl={anchorElCreate}
				onClose={handleCloseCreate}
				anchorOrigin={{
					vertical: 'center',
					horizontal: 'left'
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right'
				}}
			>
				<CreateKit onClose={handleCloseCreate} />
			</Popover>
		</Fragment>
	);
};

export default HeaderPage;
